export default __webpack_public_path__ + "static/media/notes.b7177b6b.svg";